import React from "react";

const ListSkeleton = ({ count = 4 }) => {
    return (
        <div className="space-y-4">
            {Array.from({ length: count }).map((_, index) => (
                <div key={index} className="bg-white dark:bg-sectionheaderbg border border-gray-100 dark:border-bordercolor rounded-2xl shadow-sm p-4 flex flex-col sm:flex-row sm:items-center justify-between gap-4 animate-pulse">
                    {/* Left: Avatar & Info */}
                    <div className="flex items-center gap-4">
                        {/* Avatar */}
                        <div className="w-10 h-10 rounded-full bg-slate-200 dark:bg-[#2B2B2D] shrink-0"></div>
                        
                        {/* Info Lines */}
                        <div className="flex flex-col gap-2 w-32 sm:w-48">
                            <div className="h-3 bg-slate-200 dark:bg-[#2B2B2D] rounded w-3/4"></div>
                            <div className="h-2.5 bg-slate-200 dark:bg-[#2B2B2D] rounded w-1/2"></div>
                            <div className="h-2.5 bg-slate-200 dark:bg-[#2B2B2D] rounded w-5/6"></div>
                        </div>
                    </div>

                    {/* Right: Status and Actions */}
                    <div className="flex flex-wrap items-center gap-2 sm:gap-4 ml-14 sm:ml-0">
                        {/* Status Badge */}
                        <div className="h-6 w-20 bg-slate-200 dark:bg-[#2B2B2D] rounded-full"></div>
                        {/* Action Buttons */}
                        <div className="flex items-center gap-2">
                            <div className="w-8 h-8 rounded bg-slate-200 dark:bg-[#2B2B2D]"></div>
                            <div className="w-8 h-8 rounded bg-slate-200 dark:bg-[#2B2B2D]"></div>
                            <div className="w-8 h-8 rounded bg-slate-200 dark:bg-[#2B2B2D]"></div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default ListSkeleton;
